import { MdClose } from "@react-icons/all-files/md/MdClose";
import disableScroll from "disable-scroll";
import { Link } from "gatsby";
import React from "react";

import * as styles from "../styles/SideBar.module.css";

export interface SideBarProps {
  close: () => void;
  open: boolean;
}

const SideBar = (props: SideBarProps) => {
  const goTo = (location: string) => {
    props.close();
    window.location.replace(location);
  };

  if (props.open) {
    disableScroll.on();
  } else {
    disableScroll.off();
  }

  return (
    <div>
      {props.open && <div className={styles.underlay} onClick={props.close} />}
      <div
        className={
          props.open
            ? styles.side_bar_container + " " + styles.show_side_bar
            : styles.side_bar_container
        }
      >
        <div className={styles.side_bar_header}>
          <MdClose
            size={32}
            onClick={() => {
              props.close();
            }}
          />
        </div>
        <div className={styles.side_bar_nav}>
          <a
            onClick={() => {
              goTo("/#about_us");
            }}
          >
            About us
          </a>
          <a
            onClick={() => {
              goTo("/#products");
            }}
          >
            Products
          </a>
          <a
            onClick={() => {
              goTo("/#privacy");
            }}
          >
            Privacy
          </a>
          <a
            onClick={() => {
              goTo("/#goals");
            }}
          >
            Goals
          </a>
          <a style={{textDecoration: 'none'}} href={"/faq"}>FAQ</a>
          <a
            onClick={() => {
              goTo("/#contact");
            }}
          >
            Contact us
          </a>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
